import * as React from "react"

import {BestPositionBlock} from "../../@components";


export default function bestPositionColumn() {

    return {
        name: 'bestPosition', label: 'Best Position',
        options:{
            filter: false,
            setCellHeaderProps: () => ({ sx: { textAlign: 'center' } }),
            setCellProps: () => ({ sx: { textAlign: "center" } }),

            customBodyRowRender: (value, row ) =>
                <BestPositionBlock keys={['date', 'vertical', 'horizontal']} date={value.date} vertical={value.vertical} horizontal={value.horizontal} allData={row.positions}/>
        }
    }
}